import * as LabelPrimitive from "@radix-ui/react-label";
import { type VariantProps, cva } from "class-variance-authority";

import { cn } from "@/lib/cn";

const labelVariants = cva("peer-disabled:cursor-not-allowed peer-disabled:opacity-70", {
  variants: {
    variant: {
      default: "text-sm font-medium leading-none",
      /** DESIGN.md → Label: 14px medium in sentence case, above a filter or form control */
      field: "mb-1 block text-sm font-medium text-foreground",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

interface LabelProps
  extends
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
    VariantProps<typeof labelVariants> {
  ref?: React.Ref<React.ComponentRef<typeof LabelPrimitive.Root>>;
}

const Label = ({ className, variant, ref, ...props }: LabelProps) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants({ variant }), className)} {...props} />
);
Label.displayName = LabelPrimitive.Root.displayName;

/** The `field` caption over a group of controls or plain text, where no single control is labelled */
const FieldCaption = ({ className, ...props }: React.ComponentProps<"span">) => (
  <span className={cn(labelVariants({ variant: "field" }), className)} {...props} />
);

export { FieldCaption, Label };
